/**
 *
 * Intro Note
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import RichTextIntro from '../RichTextIntro';

const styles = theme => ({
  root: {
    '& > div': {
      fontSize: '14px !important',
      lineHeight: '1.57',
      width: '100%',
      color: theme.palette.text.disabled,
      textAlign: 'left',
      paddingTop: 15,
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
});

function IntroNote(props) {
  const { classes, data } = props;
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <RichTextIntro data={data} />
      </Grid>
    </>
  );
}

IntroNote.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
};

export default withStyles(styles)(IntroNote);
